type Option = { value: string; label: string };

type Props = {
  value: string;
  onChange: (value: string) => void;
  options: Option[];
};

export default function SortSelect({ value, onChange, options }: Props) {
  return (
    <label className="flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-600">
      <i className="ri-sort-desc text-foreground-500"></i>
      <span className="hidden sm:inline">排序</span>
      <select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="cursor-pointer bg-transparent text-sm font-medium text-foreground-900 outline-none"
        aria-label="排序方式"
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </label>
  );
}